(function (angular) {
	angular.module('bizPartEngage').controller('modules.dictionary', indexController);

    indexController.$inject = ["modules.dictionary.service", "$stateParams"];

    function indexController(dictionaryService, $stateParams) {
		var vm = this;
        vm.SelectedItemId = ~~$stateParams.id;

		vm.Dictionary = [];
		vm.LettersWithWords = [];
        vm.GetDictionary = GetDictionary;

		function GetDictionary() {
			dictionaryService.GetAllEntries(-1).then(GetDictionarySuccess);

			function GetDictionarySuccess(response) {
				var dictionary = (response.data.d || response.data);

				for (var i = 0; i < dictionary.length; i++) {
					var fl = dictionary[i].Word.substring(0, 1);
					dictionary[i].FirstLetter = fl;
					if (vm.LettersWithWords.indexOf(fl) < 1) {
						vm.LettersWithWords.push(fl);
					}
				}

				vm.Dictionary = dictionary;
			}
		}

		vm.$onInit = function () {
			vm.GetDictionary();
		}
	}

})(window.angular);
